import templateUrl from './create-claim-modal.component.html';

export const CreateClaimModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controllerAs: "vm",
    controller: class CreateClaimController {
        constructor($q, utilityService, icdCorporationService, icdOfficeService) {
            'ngInject';
            this.$q = $q;
            this.utilityService = utilityService;
            this.icdCorporationService = icdCorporationService;
            this.icdOfficeService = icdOfficeService;
            this.claimType = "";
            this.claimValue = "";
        }

        handleSubmit() {
            this.onSave();
        }

        onSave() {
            if (this.resolve.role.IsProtected && this.claimType === 'apex:SuperUser') {
                alert("Super User claims cannot be altered when the role is protected.");
                return;
            } else if (this.resolve.role.Claims.some(p => p.Type === this.claimType && p.Value === this.claimValue)) {
                alert("Role already has this claim. Cancel or choose another.");
                return;
            }
            const saved = this.$q.when()
                .then(() => {
                    const claim = { Type: this.claimType, Value: this.claimValue || "" };
                    const role = this.resolve.role;
                    role.Claims.push(claim);
                    return this.role;
                })
                .then(() => {
                    this.close({ $value: this.claim })
                });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saved, "Save failed")
            );
        }

        onCancel() {
            this.dismiss({ $value: 'cancel' });
        }

        onChange() {

        }
    }
}

export const CreateClaimModal = {
    component: "apexCreateClaimModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}
